import { useEffect } from 'react';
import PropTypes from 'prop-types';

import './RawLayout.css';

/**
 * Raw page layout
 * @component
 */
const RawLayout = ({ title, children }) => {
	useEffect(() => {
		document.title = title;
	}, [title]);

	return (
		<div className="raw-layout">
			<div className="layout-workspace">{children}</div>
		</div>
	);
};

RawLayout.propTypes = {
	// Page title for the browser tab
	title: PropTypes.string.isRequired,
	// Page Layout
	children: PropTypes.node.isRequired,
};

export default RawLayout;
